import React, {Component} from 'react';
import * as d3 from 'd3';

class ScatterPlot extends Component {
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.data !== null && this.props.data !== prevProps.data && this.props.data !== undefined && this.props.data.length !== 0) {
            this.removeGraph();
            this.createGraph();
        }
    }

    createGraph() {    
        const quadrants = [
            this.props.data.q1_s1, 
            this.props.data.q1_s2, 
            this.props.data.q1_s3, 
            this.props.data.q1_s4,
            this.props.data.q2_s1, 
            this.props.data.q2_s2, 
            this.props.data.q2_s3, 
            this.props.data.q2_s4,
            this.props.data.q3_s1, 
            this.props.data.q3_s2, 
            this.props.data.q3_s3, 
            this.props.data.q3_s4,
            this.props.data.q4_s1, 
            this.props.data.q4_s2, 
            this.props.data.q4_s3, 
            this.props.data.q4_s4
        ];

        const svg = d3.select("." + this.props.name + " svg"),
            margin = {
                top: 20,
                right: 20,
                bottom: 20,
                left: 20
            },
            width = this.props.width - margin.left - margin.right,
            height = this.props.height - margin.top - margin.bottom,
            g = svg.append("g").attr("transform", "translate(" + margin.left + "," + margin.top + ")");
        svg.attr("width", '100%')
        .attr("height", '100%')
        .attr('viewBox','0 0 ' + this.props.width +' '+ this.props.height)
        .attr('preserveAspectRatio','xMinYMin');
        
        // Scales
        const scaleBottom = d3.scaleLinear()
                .domain([0, Math.max(...quadrants)])
                .range([height/2, height]);
        const scaleTop = d3.scaleLinear()
                .domain([0, Math.max(...quadrants)])
                .range([height/2, 0]);
        const scaleRight = d3.scaleLinear()
                .domain([0, Math.max(...quadrants)])
                .range([width/2, width]);        
        const scaleLeft = d3.scaleLinear()
                .domain([0, Math.max(...quadrants)])
                .range([width/2, 0]);
        const colorScale = d3.scaleQuantize()
                .domain([0, 3])
                .range(["grey", "#912424", "#571515", "gold"]);

        const topAxis = d3.axisRight(scaleTop).ticks(5).tickSize(0);
        const rightAxis = d3.axisTop(scaleRight).ticks(3).tickSize(0);
        const botAxis = d3.axisLeft(scaleBottom).ticks(3).tickSize(0);
        const leftAxis = d3.axisTop(scaleLeft).ticks(3).tickSize(0);

        const line = d3.line()
        .x(function(d) { return d.x; })
        .y(function(d) { return d.y; })
        .curve(d3.curveLinear);

        const data = [
            [
                { x: width / 2, y: scaleTop(this.props.data.q1_s1), n: this.props.data.q1_s1 },
                { x: scaleLeft(this.props.data.q1_s2), y: height / 2 , n: this.props.data.q1_s2 },
                { x: width / 2, y: scaleBottom(this.props.data.q1_s3) , n: this.props.data.q1_s3 },
                { x: scaleRight(this.props.data.q1_s4), y: height / 2 , n: this.props.data.q1_s4 },
                { x: width / 2, y: scaleTop(this.props.data.q1_s1) , n: this.props.data.q1_s1 }
            ],

            [
                { x: width / 2, y: scaleTop(this.props.data.q2_s1), n: this.props.data.q2_s1 },
                { x: scaleLeft(this.props.data.q2_s2), y: height / 2, n: this.props.data.q2_s2 },
                { x: width / 2, y: scaleBottom(this.props.data.q2_s3), n: this.props.data.q2_s3 },
                { x: scaleRight(this.props.data.q2_s4), y: height / 2, n: this.props.data.q2_s4 },
                { x: width / 2, y: scaleTop(this.props.data.q2_s1), n: this.props.data.q2_s1 }
            ],

            [
                { x: width / 2, y: scaleTop(this.props.data.q3_s1), n: this.props.data.q3_s1 },
                { x: scaleLeft(this.props.data.q3_s2), y: height / 2, n: this.props.data.q3_s2},
                { x: width / 2, y: scaleBottom(this.props.data.q3_s3), n: this.props.data.q3_s3},
                { x: scaleRight(this.props.data.q3_s4), y: height / 2, n: this.props.data.q3_s4},
                { x: width / 2, y: scaleTop(this.props.data.q3_s1), n: this.props.data.q3_s1}
            ],

            [
                { x: width / 2, y: scaleTop(this.props.data.q4_s1), n: this.props.data.q4_s1},
                { x: scaleLeft(this.props.data.q4_s2), y: height / 2, n: this.props.data.q4_s2},
                { x: width / 2, y: scaleBottom(this.props.data.q4_s3), n: this.props.data.q4_s3},
                { x: scaleRight(this.props.data.q4_s4), y: height / 2, n: this.props.data.q4_s4},
                { x: width / 2, y: scaleTop(this.props.data.q4_s1), n: this.props.data.q4_s1}
            ],
        ];

        // Lines and Circles
        for (let i = 0; i < data.length; i++) {
                let lines = g.append('g');
                lines.selectAll('circle')
                    .data(data[i])
                    .enter()
                    .append("circle")
                    .attr("cx", function(d,i) { return d.x; } )
                    .attr("cy", function(d,i) { return d.y; } )
                    .attr("r", 5)
                    .style("fill", colorScale(i));
                lines.append("path")
                    .style("fill","none")
                    .style("stroke", colorScale(i))
                    .style("stroke-width","4px")
                    .attr("d", line(data[i]));
        }

        // Axis
        g.append("g")
        .attr("transform", "translate(" + width / 2 + "," + 0 + ")")
        .attr("fill", "white")
        .call(topAxis);
        g.append("g")
        .attr("transform", "translate(" + 0 + "," + height / 2 + ")")
        .call(rightAxis);
        g.append("g")            
        .attr("transform", "translate(" + width / 2 + "," + 0 + ")")
        .call(botAxis);
        g.append("g")
        .attr("transform", "translate(" + 0 + "," + height / 2 + ")")
        .call(leftAxis);
        
        // Labels
        let label = g.append("g");
        label.append("text")
        .attr("transform", "rotate(-90)")
        .attr("y", 0 - margin.left)
        .attr("x",0 - (height / 2))
        .attr("dy", "1em")
        .style("text-anchor", "middle")
        .style("font-weight", "bold")
        .text("Software");    

        label.append("text")
        .attr("transform", "rotate(90)")
        .attr("y", 0 - width - margin.left)
        .attr("x", (height / 2))
        .attr("dy", "1em")
        .style("text-anchor", "middle")
        .style("font-weight", "bold")
        .text("Visibility"); 

        label.append("text")
        .attr("y", height)
        .attr("x", (width / 2))
        .attr("dy", "1em")
        .style("text-anchor", "middle")
        .style("font-weight", "bold")
        .text("Burn out"); 

        label.append("text")
        .attr("y", 0 - margin.left)
        .attr("x", width/2)
        .attr("dy", "1em")
        .style("text-anchor", "middle")
        .style("font-weight", "bold")        
        .text("Innovation");   

        // Legend
        const quadrantMap = {
            0: 'Creative Culture',
            1: 'Market Culture',
            2: 'Hierarchy Culture',
            3: 'Collaborative Culture'
        };

        for (let i = 0; i < 4; i++) {
            let legend = g.append("g");
            legend.append("rect")
            .attr("x", width - 155)
            .attr("y", height - i * 12 - 10)
            .attr("width", 10)
            .attr("height", 10)
            .style("fill", colorScale(i));
            legend.append("text")
            .attr("x", width - 145)
            .attr("y", height - i * 12)
            .text((quadrantMap[i]))
        }

    }

    removeGraph() {
        var svg = d3.select("." + this.props.name + " svg"),
        g = svg.select("g");
        g.remove();
    }

    render() {
        return ( 
            <div className = {this.props.name}>
                <svg></svg> 
            </div>
        );
    }
}

export default ScatterPlot;


// WEBPACK FOOTER //
// ./src/components/scatterplot.js